import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Form, Control, Errors, actions,} from 'react-redux-form'
import {Row, Col, FormGroup, FormControl, ControlLabel, Button, Checkbox} from 'react-bootstrap'
import RequiredInput from "../../../common/form/elements/required-input";
import ArrowButton from "../../../common/button-arrow";
import {validators} from "../../../../utils/validators"
import {saveUserGroup, updateUserGroup} from '../../../../actions/usergroups'
import LayoutContainer from "../../../layout/layout-container/index";

class EditUserGroupForm extends Component {

  constructor(props) {
    super(props);

    this.state = {};
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  onSubmit = (payLoad) => {
    if (this.props.userGroup.id) {
      this.props.dispatch(actions.submitFields('deep.admin_usergroup', updateUserGroup(this.props.userGroup.id, payLoad)));
    } else {
      this.props.dispatch(actions.submitFields('deep.admin_usergroup', saveUserGroup(payLoad)));
    }
  };

  // toggleRelatedPermissions = (model, value) => {
  //   const regex = /\[(\d+)\]/g;
  //   let m, permissionId;
  //
  //   while ((m = regex.exec(model)) !== null) {
  //     if (m.index === regex.lastIndex) {
  //       regex.lastIndex++;
  //     }
  //
  //     m.forEach((match, groupIndex) => {
  //       if (groupIndex === 1) {
  //         permissionId = +match;
  //       }
  //     });
  //   }
  //
  //   return (dispatch) => {
  //     const toggleParent = (value, id) => {
  //       const parentId = this.props.modelPermissions[id].parent;
  //       if (parentId) {
  //         const siblingsChecked = this.props.modelPermissions[parentId].children.filter((child) => child !== id && this.props.modelPermissions[child].checked);
  //         if (value || !siblingsChecked.length) {
  //           dispatch(actions.change(`deep.admin_usergroup.permission_ids[${parentId}].checked`, value));
  //           toggleParent(value, this.props.modelPermissions[id].parent);
  //         }
  //       }
  //     };
  //
  //     const toggleChildren = (value, id) => {
  //       this.props.modelPermissions[id].children.forEach((childId) => {
  //         dispatch(actions.change(`deep.admin_usergroup.permission_ids[${childId}].checked`, value));
  //         toggleChildren(value, childId);
  //       })
  //     };
  //
  //     dispatch(actions.change(model, value));
  //     toggleParent(value, permissionId);
  //     toggleChildren(value, permissionId);
  //   }
  // };

  generatePermissions = (permissions) => {
    if (permissions.length) {
      return (
        <FormGroup className="permission-block">
          {
            permissions.map((perm) => {
                return (
                  <LayoutContainer key={perm.id}>
                    <div className={perm.children.length ? 'has-children' : 'no-children'}>
                      <Control.checkbox model={`.permission_ids[${perm.id}].checked`}
                          // changeAction={this.toggleRelatedPermissions}
                                        component={Checkbox}>{perm.name}</Control.checkbox>
                        {this.generatePermissions(perm.children)}
                    </div>
                  </LayoutContainer>
                )
              }
            )
          }
        </FormGroup>
      )
    }
  };

  render() {
    return (
      <Form model="deep.admin_usergroup" onSubmit={this.onSubmit}>
        <Row>
          <Col lg={12}>
            <RequiredInput model=".name"
                           label="Name"
                           placeholder="Name"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {
              this.props.userGroup && this.generatePermissions(this.props.userGroup.attributes.permissions)
            }
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton color="grey"
                         className="pull-right"
                         disabled={!this.props.formValid}>Save</ArrowButton>
          </Col>
        </Row>
      </Form>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    modelPermissions: state.deep.admin_usergroup.permission_ids,
    userGroup: state.userGroups.userGroup,
    fetched: state.userGroups.fetched,
    fetching: state.userGroups.fetching,
    formValid: state.deep.forms.admin_usergroup.$form.valid,
  };
};

export default connect(mapStateToProps)(EditUserGroupForm);



// WEBPACK FOOTER //
// ./src/components/admin/usergroups/edit/usergroup-edit-form.jsx